
module.exports = san.defineComponent({
    template: require('../views/workAccidentDisablelity.html'),
    initData: function () {
        return {
            showFlag: 1,
            switchFlag: 1,
            caseType: 2,
            caseList: [],
            businessType: 3,
            explain: 0,//0:都不显示;1:伤残等级说明;2:受诉法院所在地;3:起诉年份
            provs: [{
                label: "杭州市", value: "杭州市", averageWage: [{
                    date: '2018', value: 61174
                }, {
                    date: '2017', value: 61174
                },
                {
                    date: '2016', value: 55908
                }
                ]
            },
            {
                label: "宁波市", value: "宁波市", averageWage: [{
                    date: '2018', value: 61342
                }, {
                    date: '2017', value: 61342
                },
                {
                    date: '2016', value: 57550
                }
                ]
            },
            {
                label: "温州市", value: "温州市", averageWage: [{
                    date: '2018', value: 52499
                }, {
                    date: '2017', value: 52499
                },
                {
                    date: '2016', value: 50719
                }
                ]
            },
            {
                label: "金华市", value: "金华市", averageWage: [{
                    date: '2018', value: 51618
                }, {
                    date: '2017', value: 51618
                },
                {
                    date: '2016', value: 48286
                }
                ]
            },
            {
                label: "台州市", value: "台州市", averageWage: [{
                    date: '2018', value: 54745
                }, {
                    date: '2017', value: 54745
                },
                {
                    date: '2016', value: 50652
                }
                ]
            },
            {
                label: "嘉兴市", value: "嘉兴市", averageWage: [{
                    date: '2018', value: 55530
                }, {
                    date: '2017', value: 55530
                },
                {
                    date: '2016', value: 51890
                }
                ]
            },
            {
                label: "湖州市", value: "湖州市", averageWage: [{
                    date: '2018', value: 50715
                }, {
                    date: '2017', value: 50715
                },
                {
                    date: '2016', value: 55086
                }
                ]
            },
            {
                label: "绍兴市", value: "绍兴市", averageWage: [{
                    date: '2018', value: 51388
                }, {
                    date: '2017', value: 51388
                },
                {
                    date: '2016', value: 50967
                }
                ]
            },
            {
                label: "衢州市", value: "衢州市", averageWage: [{
                    date: '2018', value: 48024
                }, {
                    date: '2017', value: 48024
                },
                {
                    date: '2016', value: 43857
                }
                ]
            },
            {
                label: "丽水市", value: "丽水市", averageWage: [{
                    date: '2018', value: 44597
                }, {
                    date: '2017', value: 44597
                },
                {
                    date: '2016', value: 39862
                }
                ]
            },
            {
                label: "舟山市", value: "舟山市", averageWage: [{
                    date: '2018', value: 53040
                }, {
                    date: '2017', value: 53040
                },
                {
                    date: '2016', value: 48240
                }
                ]
            }],
            citys: [
                { label: '下城区', value: '下城区', limitLevel: '1' },
                { label: '江干区', value: '江干区', limitLevel: '1' },
                { label: '拱墅区', value: '拱墅区', limitLevel: '1' },
                { label: '西湖区', value: '西湖区', limitLevel: '1' },
                { label: '滨江区', value: '滨江区', limitLevel: '1' },
                { label: '余杭区', value: '余杭区', limitLevel: '1' },
                { label: '萧山区', value: '萧山区', limitLevel: '1' },
                { label: '富阳区', value: '富阳区', limitLevel: '1' },
                { label: '临安区', value: '临安区', limitLevel: '3' },
                { label: '建德市', value: '建德市', limitLevel: '3' },
                { label: '桐庐县', value: '桐庐县', limitLevel: '3' },
                { label: '淳安县', value: '淳安县', limitLevel: '3' }
            ],
            selectProv: {
                label: '杭州市', value: '杭州市', averageWage: [{
                    date: '2018', value: 61174
                }, {
                    date: '2017', value: 61174
                }, {
                    date: '2016', value: 55908
                }
                ]
            },
            selectCity: { label: '西湖区', value: '西湖区', limitLevel: '1' },
            areaAverageWage: 61174,
            disposableIncome: 0,
            params: {
                level: 1, //伤残等级
                rely: '0', //生活护理等级
                averageWage: 5091.58, //地方平均工资（2016年浙江省）
                disposableIncome: 0,  //实际月缴费工资
                shutDownDate: 0,  //停工留薪期
                shutDownIncome: 0, //停工留薪期工资
                shutType: '1',
                sex: '1', //性别
                age: '', //年龄
                birthdate: '',//出生日期
                isOnePay: '1',//是否要求一次性支付医疗保险 1-是 2-否
                isPayInsurance: '1',//是否缴纳保险 1-是 2-否
                shutWorkTime: '01/01/2020',  //停止工作时间
                accidentStartTime: '01/01/2020', //事故发生时间
                hospitalType: '1',
                isHaveNurse: '2',//	用人单位是否已安排落实:1-是 2-否
                hospitalNurse: 0,//住院护理费
                nutritionDay: 0,//护理期限
                nurseType: '1',
                limit: 2010,//当地最低工资
                limitLevel: '1',//当地最低工资等级
                isWorking: '1',//是否解除或终止劳动合同关系 1-是 2-否
                isWorked: '1',//是否退出工作岗位 1-是 2-否
                isHaveMedical: '2',
                inDay: 0,//住院天数
                medical: 0,//医疗费
                nurse: 0,//护理费
                cure: 0, //康复治疗费
                identify: 0,//鉴定费
                traffic: 0,//交通费
                assist: 0,//残疾辅助器具费用
            },
            result: {
                suspensionDamage: 0,//工资福利待遇
                disabilityDamage: 0,//一次性伤残补助金
                subsidyDamage: 0,//伤残津贴（每月）
                elderInsuranceIncome: 0,//基本养老保险待遇
                medicalInsuranceIncome: 0,
                trafficDamage: 0,//交通食宿费
                assistDamage: 0,//残疾辅助器具费
                medicalDamage: 0,//医疗费
                medicalSubsidy: 0,//一次性医疗补助金
                hospitalNurseDamage: 0,//住院护理费
                inpatientFoodDamage: 0,//住院伙食补助费
                workDamage: 0,//一次性就业补助金
                cureDamage: 0, //康复治疗费
                nurseDamage: 0,//护理费（每月）
                identifyDamage: 0,//鉴定费
            }
        }
    },
    components: {

    },
    created: function () {
        this.getWorkLostTime();
        this.data.set('disposableIncome', parseFloat((this.data.get('params.averageWage') * 0.6)).toFixed(2));
    },
    attached: function () {
        var me = this;
        $('#mydatepicker').duDatepicker().on('datechanged', function (e) {
            me.data.set('params.birthdate', e.date);
            me.selectTime();
        }); //初始化日期选择器
        $('#datepicker2').duDatepicker().on('datechanged', function (e) {
            me.data.set('params.accidentStartTime', e.date);
            me.getAciidentTime();
        }); //初始化日期选择器
    },
    reset: function () {
        this.data.set('showFlag', 1);
        this.data.set('disposableIncome', parseFloat((this.data.get('params.averageWage') * 0.6)).toFixed(2));
        this.data.set('selectProv', {
            label: '杭州市', value: '杭州市', averageWage: [{
                date: '2018', value: 61174
            }, {
                date: '2017', value: 61174
            }, {
                date: '2016', value: 55908
            }
            ]
        });
        this.data.set('selectCity', { label: '西湖区', value: '西湖区', limitLevel: '1' });
        this.data.set('areaAverageWage', 61174);
        this.data.set('params', {
            level: 1,//伤残等级
            rely: '0',//生活护理等级
            disposableIncome: 0,//实际月工资
            averageWage: 5091.58, //地方平均工资（2016年浙江省）
            shutType: '1',
            shutDownDate: 0,//停工留薪
            shutDownIncome: 0, //停工留薪期工资
            isOnePay: '1',//是否要求一次性支付医疗保险 1-是 2-否
            isPayInsurance: '1',//是否缴纳保险 1-是 2-否
            shutWorkTime: '01/01/2020',  //停止工作时间
            accidentStartTime: '01/01/2020', //事故发生时间
            hospitalType: '1',
            isHaveNurse: '2',//	用人单位是否已安排落实:1-是 2-否
            hospitalNurse: 0,//住院护理费
            nutritionDay: 0,//护理期限
            nurseType: '1',
            limit: 2010,//当地最低工资
            limitLevel: '1',//当地最低工资等级
            inDay: 0,//住院天数
            medical: 0,//医疗费
            isWorking: '1',//是否解除或终止劳动合同关系 1-是 2-否
            isWorked: '1',//是否退出工作岗位 1-是 2-否
            isHaveMedical: '2',
            nurse: 0,//护理费
            cure: 0, //康复治疗费
            identify: 0,//鉴定费
            traffic: 0,//交通费
            assist: 0,//残疾辅助器具费用
        });
        this.data.set('result', {
            suspensionDamage: 0,//工资福利待遇
            disabilityDamage: 0,//一次性伤残补助金
            elderInsuranceIncome: 0,//基本养老保险待遇
            medicalInsuranceIncome: 0,
            subsidyDamage: 0,//伤残津贴（每月）
            trafficDamage: 0,//交通食宿费
            assistDamage: 0,//残疾辅助器具费
            medicalDamage: 0,//医疗费，
            medicalSubsidy: 0,//一次性医疗补助金
            hospitalNurseDamage: 0,//住院护理费
            inpatientFoodDamage: 0,//住院伙食补助费
            workDamage: 0,//一次性就业补助金
            cureDamage: 0, //康复治疗费
            nurseDamage: 0,//护理费（每月）
            identifyDamage: 0,//鉴定费
        })
    },
    getAciidentTime: function () {
        this.getLimit(new Date(this.data.get('params.accidentStartTime')).getTime(), this.data.get('params.limitLevel'));
    },
    getWorkLostTime: function () {
        switch (new Date(this.data.get('params.shutWorkTime')).getFullYear()) {
            case 2020: this.data.set('params.averageWage', 5536);
                break;
            case 2019: this.data.set('params.averageWage', 5536);
                break;
            case 2018: this.data.set('params.averageWage', 5091.58);
                break;
            case 2017: this.data.set('params.averageWage', 4698.75);
                break;
            case 2016: this.data.set('params.averageWage', 4309.92);
                break;
            default: this.data.set('params.averageWage', 5536);
                break;
        }
        this.getAverageWage(new Date(this.data.get('params.shutWorkTime')).getFullYear());
    },
    getLevel: function (level) {
        if (level > 4) {
            var me = this;
            $('#picker3').duDatepicker().on('datechanged', function (e) {
                me.data.set('params.shutWorkTime', e.date);
                me.getWorkLostTime();
            }); //初始化日期选择器
        }
    },
    getData: function () {
        var data = [{
            label: "杭州市",
            value: "杭州市",
            children: [{ label: '下城区', value: '下城区', limitLevel: '1' },
            { label: '江干区', value: '江干区', limitLevel: '1' },
            { label: '拱墅区', value: '拱墅区', limitLevel: '1' },
            { label: '西湖区', value: '西湖区', limitLevel: '1' },
            { label: '滨江区', value: '滨江区', limitLevel: '1' },
            { label: '余杭区', value: '余杭区', limitLevel: '1' },
            { label: '萧山区', value: '萧山区', limitLevel: '1' },
            { label: '富阳区', value: '富阳区', limitLevel: '1' },
            { label: '临安区', value: '临安区', limitLevel: '3' },
            { label: '建德市', value: '建德市', limitLevel: '3' },
            { label: '桐庐县', value: '桐庐县', limitLevel: '3' },
            { label: '淳安县', value: '淳安县', limitLevel: '3' }]
        },
        {
            label: "宁波市",
            value: "宁波市",
            children: [{ label: '海曙区', value: '海曙区', limitLevel: '1' },
            { label: '江东区', value: '江东区', limitLevel: '1' },
            { label: '江北区', value: '江北区', limitLevel: '1' },
            { label: '镇海区', value: '镇海区', limitLevel: '1' },
            { label: '北仑区', value: '北仑区', limitLevel: '1' },
            { label: '鄞州区', value: '鄞州区', limitLevel: '1' },
            { label: '慈溪市', value: '慈溪市', limitLevel: '2' },
            { label: '余姚市', value: '余姚市', limitLevel: '2' },
            { label: '宁波杭州湾新区', value: '宁波杭州湾新区', limitLevel: '2' },
            { label: '象山县', value: '象山县', limitLevel: '3' },
            { label: '奉化区', value: '奉化区', limitLevel: '3' },
            { label: '宁海县', value: '宁海县', limitLevel: '3' }]
        },
        {
            label: "温州市",
            value: "温州市",
            children: [{ label: '鹿城区', value: '鹿城区', limitLevel: '1' },
            { label: '龙湾区', value: '龙湾区', limitLevel: '1' },
            { label: '瓯海区', value: '瓯海区', limitLevel: '1' },
            { label: '温州经济技术开发区', value: '温州经济技术开发区', limitLevel: '1' },
            { label: '乐清市', value: '乐清市', limitLevel: '2' },
            { label: '瑞安市', value: '瑞安市', limitLevel: '2' },
            { label: '永嘉县', value: '永嘉县', limitLevel: '3' },
            { label: '平阳县', value: '平阳县', limitLevel: '3' },
            { label: '苍南县', value: '苍南县', limitLevel: '3' },
            { label: '文成县', value: '文成县', limitLevel: '3' },
            { label: '泰顺县', value: '泰顺县', limitLevel: '3' },
            { label: '洞头县', value: '洞头县', limitLevel: '3' }]
        },
        {
            label: "金华市",
            value: "金华市",
            children: [{ label: '婺城区', value: '婺城区', limitLevel: '2' },
            { label: '金东区', value: '金东区', limitLevel: '2' },
            { label: '义乌市', value: '义乌市', limitLevel: '2' },
            { label: '东阳市', value: '东阳市', limitLevel: '2' },
            { label: '永康市', value: '永康市', limitLevel: '2' },
            { label: '兰西县', value: '兰西县', limitLevel: '3' },
            { label: '浦江县', value: '浦江县', limitLevel: '3' },
            { label: '武义县', value: '武义县', limitLevel: '3' },
            { label: '磐安县', value: '磐安县', limitLevel: '4' }]
        },
        {
            label: "台州市",
            value: "台州市",
            children: [{ label: '椒江区', value: '椒江区', limitLevel: '2' },
            { label: '黄岩区', value: '黄岩区', limitLevel: '2' },
            { label: '路桥区', value: '路桥区', limitLevel: '2' },
            { label: '临海市', value: '临海市', limitLevel: '2' },
            { label: '温岭市', value: '温岭市', limitLevel: '2' },
            { label: '玉环县', value: '玉环县', limitLevel: '2' },
            { label: '仙居县', value: '仙居县', limitLevel: '3' },
            { label: '天台县', value: '天台县', limitLevel: '3' },
            { label: '三门县', value: '三门县', limitLevel: '3' }]
        },
        {
            label: "湖州市",
            value: "湖州市",
            children: [{ label: '吴兴区', value: '吴兴区', limitLevel: '2' },
            { label: '南浔区', value: '南浔区', limitLevel: '2' },
            { label: '菱湖区', value: '菱湖区', limitLevel: '2' },
            { label: '德清市', value: '德清市', limitLevel: '3' },
            { label: '安吉县', value: '安吉县', limitLevel: '3' },
            { label: '长兴县', value: '长兴县', limitLevel: '3' }]
        },
        {
            label: "嘉兴市",
            value: "嘉兴市",
            children: [{ label: '南湖区', value: '南湖区', limitLevel: '2' },
            { label: '秀洲区', value: '秀洲区', limitLevel: '2' },
            { label: '平湖市', value: '平湖市', limitLevel: '2' },
            { label: '海宁市', value: '海宁市', limitLevel: '2' },
            { label: '桐乡市', value: '桐乡市', limitLevel: '2' },
            { label: '海盐县', value: '海盐县', limitLevel: '2' },
            { label: '嘉善县', value: '嘉善县', limitLevel: '2' }]
        },
        {
            label: "绍兴市",
            value: "绍兴市",
            children: [{ label: '越城区', value: '越城区', limitLevel: '2' },
            { label: '诸暨市', value: '诸暨市', limitLevel: '2' },
            { label: '嵊州市', value: '嵊州市', limitLevel: '2' },
            { label: '上虞市', value: '上虞市', limitLevel: '2' },
            { label: '新昌县', value: '新昌县', limitLevel: '2' },
            { label: '柯桥区', value: '柯桥区', limitLevel: '2' },
            { label: '绍兴县', value: '绍兴县', limitLevel: '2' }]
        },
        {
            label: "衢州市",
            value: "衢州市",
            children: [{ label: '柯城区', value: '柯城区', limitLevel: '3' },
            { label: '衢江区', value: '衢江区', limitLevel: '3' },
            { label: '龙游县', value: '龙游县', limitLevel: '3' },
            { label: '江山县', value: '江山县', limitLevel: '3' },
            { label: '常山县', value: '常山县', limitLevel: '3' },
            { label: '开化县', value: '开化县', limitLevel: '3' }]
        },
        {
            label: "丽水市",
            value: "丽水市",
            children: [{ label: '莲都区', value: '莲都区', limitLevel: '3' },
            { label: '青田县', value: '青田县', limitLevel: '3' },
            { label: '缙云县', value: '缙云县', limitLevel: '3' },
            { label: '龙泉市', value: '龙泉市', limitLevel: '4' },
            { label: '云和县', value: '云和县', limitLevel: '4' },
            { label: '景宁县', value: '景宁县', limitLevel: '4' },
            { label: '松阳县', value: '松阳县', limitLevel: '4' },
            { label: '遂昌县', value: '遂昌县', limitLevel: '4' },
            { label: '庆元县', value: '庆元县', limitLevel: '4' }]
        },
        {
            label: "舟山市",
            value: "舟山市",
            children: [{ label: '定海区', value: '定海区', limitLevel: '3' },
            { label: '普陀区', value: '普陀区', limitLevel: '3' },
            { label: '岱山县', value: '岱山县', limitLevel: '3' },
            { label: '嵊泗县', value: '嵊泗县', limitLevel: '3' }]
        }
        ];
        return data;
    },
    getProv: function (prov) {
        var tempCity = [];
        var allCity = this.getData();
        var me = this;
        this.data.get('provs').forEach(function (val) {
            if (prov == val.value) {
                me.data.set('selectProv', val);
            }
        });
        allCity.forEach(function (val) {
            if (prov == val.value) {
                tempCity = val.children;
            }
        });
        this.data.set('citys', tempCity);
        this.data.set('selectCity', tempCity[0]);
        this.data.set('params.limitLevel', tempCity[0].limitLevel);
        this.getLimit(this.data.get('params.accidentStartTime'), tempCity[0].limitLevel);
        this.getAverageWage(this.data.get('params.shutWorkTime'));
    },
    getCity: function (city) {
        var accidentStartTime = new Date(this.data.get('params.accidentStartTime')).getFullYear();
        var accidentStartTime2 = new Date(this.data.get('params.accidentStartTime')).getTime();
        var allCity = this.getData();
        if (city == '富阳区' && accidentStartTime == '2016') {
            this.data.set('params.limitLevel', '2');
            this.getLimit(accidentStartTime2, '2');
            return;
        }
        if (city == '洞头县' && accidentStartTime == '2016') {
            this.data.set('params.limitLevel', '2');
            this.getLimit(accidentStartTime2, '2');
            return;
        }
        if (this.data.get('selectProv.label') == "舟山市" && accidentStartTime == '2016') {
            this.data.set('params.limitLevel', '2');
            this.getLimit(accidentStartTime2, '2');
            return;
        }
        var limitLevel;
        var me = this;
        allCity.forEach(function (val) {
            if (me.data.get('selectProv.label') == val.label) {
                val.children.forEach(function (val2) {
                    if (val2.label == city) {
                        limitLevel = val2.limitLevel;
                    }
                });
            }
        });
        this.data.set('params.limitLevel', limitLevel);
        this.getLimit(accidentStartTime2, limitLevel);
    },
    getAverageWage: function (t) {
        var me = this;
        var find = false;
        this.data.get('selectProv.averageWage').forEach(function (val) {
            if (t == val.date) {
                me.data.set('areaAverageWage', val.value);
                find = true;
            }
        });
        if (!find) {
            me.data.set('areaAverageWage', this.data.get('selectProv.averageWage')[0].value);
        }
    },
    getLimit: function (t, c) {
        if (t >= 1512086400000) {
            switch (c) {
                case '1': this.data.set('params.limit', 2010);
                    break;
                case '2': this.data.set('params.limit', 1800);
                    break;
                case '3': this.data.set('params.limit', 1660);
                    break;
                case '4': this.data.set('params.limit', 1500);
                    break;
            }
        } else {
            switch (c) {
                case '1': this.data.set('params.limit', 1860);
                    break;
                case '2': this.data.set('params.limit', 1660);
                    break;
                case '3': this.data.set('params.limit', 1530);
                    break;
                case '4': this.data.set('params.limit', 1380);
                    break;
            }
        }
    },
    selectTime: function () {
        this.data.set('params.age', parseInt((new Date() * 1 - new Date(this.data.get('params.birthdate')) * 1) / 86400000 / 365));
    },
    count: function () {

        if (this.data.get('params.shutType') == 1) {
            //工资福利待遇
            if (this.data.get('params.shutDownDate') <= 24) {
                this.data.set('result.suspensionDamage', parseFloat(parseFloat(this.data.get('params.shutDownIncome') * this.data.get('params.shutDownDate')).toFixed(2)));
            } else {
                this.data.set('result.suspensionDamage', parseFloat(parseFloat(this.data.get('params.shutDownIncome') * 24)));
            }
        } else {
            if (this.data.get('params.shutDownDate') <= (365 * 2)) {
                this.data.set('result.suspensionDamage', parseFloat((this.data.get('params.shutDownIncome') * 12 / 365 * this.data.get('params.shutDownDate')).toFixed(2)));
            } else {
                this.data.set('result.suspensionDamage', parseFloat((this.data.get('params.shutDownIncome') * 12 * 2).toFixed(2)));
            }
        }

        //本人缴费工资基数
        this.data.set('params.disposableIncome', this.data.get('disposableIncome'));
        if (this.data.get('params.disposableIncome') < parseFloat(parseFloat(this.data.get('params.averageWage') * 0.6).toFixed(2))) {
            this.data.set('params.disposableIncome', parseFloat(parseFloat(this.data.get('params.averageWage') * 0.6).toFixed(2)));
        }
        if (this.data.get('params.disposableIncome') > parseFloat(parseFloat(this.data.get('params.averageWage') * 3).toFixed(2))) {
            this.data.set('params.elderInsuranceIncome', parseFloat(parseFloat(this.params.averageWage * 3).toFixed(2)));
        }
        //一次性伤残补助金
        if (this.data.get('params.level') <= 6) {
            this.data.set('result.disabilityDamage', parseFloat(parseFloat(((18 - (this.data.get('params.level') - 5) * 2)) * this.data.get('params.disposableIncome')).toFixed(2)));
            if (this.data.get('params.level') <= 4) {
                this.data.set('result.disabilityDamage', parseFloat(parseFloat(((27 - (this.data.get('params.level') - 1) * 2)) * this.data.get('params.disposableIncome')).toFixed(2)));
            }
        } else {
            this.data.set('result.disabilityDamage', parseFloat(parseFloat(((13 - (this.data.get('params.level') - 7) * 2)) * this.data.get('params.disposableIncome')).toFixed(2)));
        }

        //伤残津贴（每月）
        if (this.data.get('params.level') <= 4) {
            this.data.set('result.subsidyDamage', parseFloat(parseFloat(this.data.get('params.disposableIncome') * ((90 - (this.data.get('params.level') - 1) * 5) / 100)).toFixed(2)));
            if ((this.data.get('params.sex') == 1 && this.data.get('params.age') >= 60) || (this.data.get('params.sex') == 2 && this.data.get('params.age') >= 55) || this.data.get('params.isPayInsurance') == 2) {
                this.data.set('result.subsidyDamage', 0);
            }
        } else if (this.data.get('params.level' == 5)) {
            this.data.set('result.subsidyDamage', parseFloat(parseFloat(this.data.get('params.disposableIncome') * (70 / 100)).toFixed(2)));
            if (this.data.get('params.isWorked') == 2 || this.data.get('params.isWorking') == 1) {
                this.data.set('result.subsidyDamage', 0);
            }
        } else if (this.data.get('params.level') == 6) {
            this.data.set('result.subsidyDamage', parseFloat(parseFloat(this.data.get('params.disposableIncome') * (60 / 100)).toFixed(2)));
            if (this.data.get('params.isWorked') == 2 || this.data.get('params.isWorking') == 1) {
                this.data.set('result.subsidyDamage', 0);
            }
        } else {
            this.data.set('result.subsidyDamage', 0);
        }
        (this.data.get('result.subsidyDamage') > 0 && this.data.get('result.subsidyDamage') < this.data.get('params.limit')) ? this.data.set('result.subsidyDamage', this.data.get('params.limit')) : '';

        //养老保险
        var days = parseInt((new Date() * 1 - new Date(this.data.get('params.birthdate')) * 1) / 86400000);
        if (this.data.get('params.level') <= 4 && ((this.data.get('params.sex') == 1 && this.data.get('params.age') >= 60) || (this.data.get('params.sex') == 2 && this.data.get('params.age') >= 55))) {
            if (this.data.get('params.sex') == 1 && this.data.get('params.age') >= 60) {
                this.data.set('result.elderInsuranceIncome', parseFloat(parseFloat(this.data.get('params.disposableIncome') * 12 / 365 * (days - 60 * 365)).toFixed(2)));
            }
            if (this.data.get('params.sex') == 2 && this.data.get('params.age') >= 55) {
                this.data.set('result.elderInsuranceIncome', parseFloat(parseFloat(this.data.get('params.disposableIncome') * 12 / 365 * (days - 55 * 365)).toFixed(2)));
            }

        } else {
            this.data.set('result.elderInsuranceIncome', 0);
        }

        //一次性支付的工伤保险待遇
        if (this.data.get('params.level') <= 4 && this.data.get('params.isPayInsurance') == 2) {
            this.data.set('result.medicalInsuranceIncome', this.data.get('params.disposableIncome'));
            if (this.data.get('params.isOnePay') == 1) {
                this.data.set('result.medicalInsuranceIncome', this.data.get('params.averageWage') * 12 * (16 - (this.data.get('params.level') - 1) * 2));
            }
        } else {
            this.data.set('result.medicalInsuranceIncome', 0);
        }

        //护理费
        if (this.data.get('params.isHaveNurse') == 2) {
            if (this.data.get('params.hospitalType') == 1) {
                this.data.set('result.hospitalNurseDamage', parseFloat(parseFloat(this.data.get('params.hospitalNurse')).toFixed(2)));
            } else {
                if (this.data.get('params.nurseType') == 1) {
                    if (this.data.get('params.hospitalNurse') <= this.data.get('params.averageWage')) {
                        this.data.set('result.hospitalNurseDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * this.data.get('params.nutritionDay')).toFixed(2)));
                    } else {
                        this.data.set('result.hospitalNurseDamage', parseFloat(parseFloat(this.data.get('params.hospitalNurse') * this.data.get('params.nutritionDay')).toFixed(2)))
                    }
                } else {
                    if (this.data.get('params.hospitalNurse') <= this.data.get('params.averageWage')) {
                        this.data.set('result.hospitalNurseDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 12 / 365 * this.data.get('params.nutritionDay')).toFixed(2)));
                    } else {
                        this.data.set('result.hospitalNurseDamage', parseFloat(parseFloat(this.data.get('params.hospitalNurse') * 12 / 365 * this.data.get('params.nutritionDay')).toFixed(2)))
                    }
                }
            }

        } else {
            this.data.set('result.hospitalNurseDamage', 0);
        }

        //住院伙食补助费
        this.data.set('result.inpatientFoodDamage', parseFloat(parseFloat((this.data.get('params.limit') * 35 / 100 * (12 / 365)) * this.data.get('params.inDay')).toFixed(2)));

        //生活护理费（每月）
        if (this.data.get('params.rely') != 0) {
            switch (this.data.get('params.rely')) {
                case '1': this.data.set('result.nurseDamage', parseFloat(parseFloat((this.data.get('areaAverageWage') / 12) * 50 / 100).toFixed(2)));
                    break;
                case '2': this.data.set('result.nurseDamage', parseFloat(parseFloat((this.data.get('areaAverageWage') / 12) * 40 / 100).toFixed(2)));
                    break;
                case '3': this.data.set('result.nurseDamage', parseFloat(parseFloat((this.data.get('areaAverageWage') / 12) * 30 / 100).toFixed(2)));
                    break;
            }
        } else {
            this.data.set('result.nurseDamage', 0);
        }

        //一次性医疗补助金
        if (this.data.get('params.isWorking') == 1 && this.data.get('params.level') >= 5) {
            switch (this.data.get('params.level')) {
                case '5': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 30).toFixed(2)));
                    break;
                case '6': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 25).toFixed(2)));
                    break;
                case '7': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 10).toFixed(2)));
                    break;
                case '8': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 7).toFixed(2)));
                    break;
                case '9': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 4).toFixed(2)));
                    break;
                case '10': this.data.set('result.medicalSubsidy', parseFloat(parseFloat(this.data.get('params.averageWage') * 2).toFixed(2)));
                    break;
            }
        } else {
            this.data.set('result.medicalSubsidy', 0);
        }

        var age = parseInt((new Date(this.data.get('params.shutWorkTime')) * 1 - new Date(this.data.get('params.birthdate')) * 1) / 86400000 / 365);
        //一次性就业补助金
        if (this.data.get('params.isWorking') == 1 && this.data.get('params.level') >= 5) {
            var coefficient = 1;
            if (this.data.get('params.sex') == 1 && age > 55) {
                coefficient = coefficient - (age - 55) * 0.2;
            }
            if (this.data.get('params.sex') == 2 && age > 50) {
                coefficient = coefficient - (age - 50) * 0.2;
            }
            coefficient < 0 ? coefficient = 0 : '';
            switch (this.data.get('params.level')) {
                case '5': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 30 * coefficient).toFixed(2)));
                    break;
                case '6': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 25 * coefficient).toFixed(2)));
                    break;
                case '7': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 10 * coefficient).toFixed(2)));
                    break;
                case '8': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 7 * coefficient).toFixed(2)));
                    break;
                case '9': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 4 * coefficient).toFixed(2)));
                    break;
                case '10': this.data.set('result.workDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 2 * coefficient).toFixed(2)));
                    break;
            }
        } else {
            this.data.set('result.workDamage', 0);
        }

        //医疗费，根据发票报销，自己填
        if (this.data.get('params.isHaveMedical') == 2) {
            this.data.set('result.medicalDamage', parseFloat(parseFloat(this.data.get('params.medical')).toFixed(2)));
        } else {
            this.data.set('result.medicalDamage', 0);
        }

        //残疾辅助器具费用，自己填
        this.data.set('result.assistDamage', parseFloat(parseFloat(this.data.get('params.assist')).toFixed(2)));
        //康复治疗费，根据发票报销，自己填
        this.data.set('result.identifyDamage', parseFloat(parseFloat(this.data.get('params.identify')).toFixed(2)));
        //鉴定费，根据发票报销，自己填
        this.data.set('result.cureDamage', parseFloat(parseFloat(this.data.get('params.cure')).toFixed(2)));
        //交通费，自己填
        this.data.set('result.trafficDamage', parseFloat(parseFloat(this.data.get('params.traffic')).toFixed(2)));

        //合计
        this.data.set('result.totalDamage', parseFloat(this.data.get('result.suspensionDamage') + this.data.get('result.disabilityDamage') +
            this.data.get('result.hospitalNurseDamage') + this.data.get('result.inpatientFoodDamage') + this.data.get('result.medicalSubsidy') +
            this.data.get('result.workDamage') + this.data.get('result.medicalDamage') + this.data.get('result.assistDamage') +
            this.data.get('result.identifyDamage') + this.data.get('result.cureDamage') + this.data.get('result.trafficDamage')).toFixed(2));

        this.data.set('showFlag', 2);

        for (var i in this.data.get('result')) {
            this.data.set('result.' + i, window.changeNum._formatNum(this.data.get('result.' + i) + ''));
        }

        this.dispatch('goScroll', $('.count')[0].offsetTop + 95);
    },
    createReport: function () {
        this.data.set('switchFlag', 2);
        this.dispatch('goTo', $('.createReport')[0].offsetTop);

        //获取案例接口
        var params = {
            caseType: this.data.get('caseType'),
            disabilityLevel: this.data.get('params.level')
        };
        var me = this;
        Api("post", "/api/calculation/v2/getCaseList", JSON.stringify(params)).then(function (response) {
            if (response) {
                me.data.set('caseList', response.caseList);
            }
        });

        var data = {
            userId: localStorage.sysUserId,
            calculationType: this.data.get('businessType'),
            sourceType: 2,
            sourceTerminalId: 1,
            calculationParams: this.data.get('params'),
            calculationResult: this.data.get('result'),
        };
        Api("post", "/api/calculation/v2/saveCalculationLog", JSON.stringify(data)).then(function (response) { });
    },
    createCort: function (t) {
        this.dispatch('createCort', t);
    },
    back: function (flag) {
        this.data.set('switchFlag', flag);
    },
    toggle: function (e) {
        var args = e.target || e.srcElement;
        args.value == 0 ? args.value = '' : args.value = args.value;
    },
    toggle2: function (e) {
        var args = e.target || e.srcElement;
        args.value == '' ? args.value = 0 : args.value = args.value;
        var num = Number(args.value);
        (isNaN(num)) ? args.value = 0 : args.value = args.value;
    },
    hide: function () {
        this.data.set('explain', 0);
    },
    getExplain: function (type) {
        if (type == 1) {
            this.data.set('explain', 1);
        } else if (type == 2) {
            this.data.set('explain', 2);
        } else if (type == 3) {
            this.data.set('explain', 3);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/workAccidentDisability.js
// module id = 362
// module chunks = 1